import { ChangeEvent, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  isOpponentTurnSpeedUpEnabled,
  setOpponentTurnSpeedUpEnabled,
} from 'phaser-wars';

export default function SettingsPage() {
  const location = useLocation();
  // Same { from: location } shape App.tsx's RequireAuth/PublicOnly already
  // use for post-login redirects — set by game/[id].tsx's handleOpenSettings
  // when navigating here from the in-game menu. Only present in that case,
  // so the link below only shows up when there's actually a game to return
  // to (not when Settings was reached from the navbar).
  const from = (location.state as { from?: Location } | null)?.from;
  const backToGame = from ? `${from.pathname}${from.search}` : null;

  const [speedUpEnabled, setSpeedUpEnabled] = useState(() =>
    isOpponentTurnSpeedUpEnabled()
  );

  const handleToggleSpeedUp = (event: ChangeEvent<HTMLInputElement>) => {
    setOpponentTurnSpeedUpEnabled(event.target.checked);
    setSpeedUpEnabled(event.target.checked);
  };

  return (
    <div className="columns">
      <div className="column is-half is-offset-one-quarter">
        {backToGame && (
          <Link to={backToGame} className="button is-light mb-4">
            ← Back to game
          </Link>
        )}
        <h2 className="title is-3">Settings</h2>

        <div className="box">
          <h3 className="title is-5">Gameplay</h3>
          <label
            className="checkbox is-flex is-align-items-center mb-2"
            style={{ gap: 8 }}
          >
            <input
              type="checkbox"
              checked={speedUpEnabled}
              onChange={handleToggleSpeedUp}
            />
            <span>Speed up opponent turns (hold to fast-forward)</span>
          </label>
          <p style={{ color: 'var(--text-secondary)' }}>
            While watching an AI or another player's turn, press and hold
            anywhere on the board to fast-forward it, and camera panning is
            locked for that turn so the same gesture doesn't also move the
            camera (pinch/scroll zoom still work). Turn this off to keep full
            camera control during their turn instead.
          </p>
        </div>
      </div>
    </div>
  );
}
